
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import NModalWindow from '@/uikit/modal-window/NModalWindow.vue';
import CardItemTile from '@/components/cards/CardItemTile.vue';
import { CarCard, HumanCard } from '@/api';
import NButton from '@/uikit/buttons/NButton.vue';
import ThumbnailItem from '@/components/common/ThumbnailItem.vue';
import NTextDelimiter from '@/uikit/text/NTextDelimiter.vue';

@Options({
  name: 'CardsDuplicateDialog',
  components: { NTextDelimiter, ThumbnailItem, NButton, CardItemTile, NModalWindow },
  emits: ['addToCard', 'close']
})
export default class CardsDuplicateDialog extends Vue {
  @Prop({ type: String })
  image!: string;

  @Prop({ type: Array })
  cards!: HumanCard[] | CarCard[];

  @Prop({ type: String })
  cardType = '';

  @Prop({ type: Number })
  currentCardId?: number;
}
